<template>
  <section class="settings-card">
    <div class="card-header">
      <div>
        <h2 class="card-title blue">QC 管理</h2>
        <p class="card-desc">管理 QC 审核人员，支持导入和手动添加</p>
      </div>
      <div style="display:flex;gap:10px;align-items:center">
        <el-button type="warning" size="small" @click="exportTemplate">导出 QC 模板</el-button>
        <el-upload :action="uploadUrl" :headers="uploadHeaders" :data="{ projectId: projectId }" :on-success="onImportSuccess" :on-error="onImportError" :show-file-list="false" accept=".xlsx,.xls" style="display:inline-block">
          <el-button type="success" size="small">导入审核人员</el-button>
        </el-upload>
      </div>
    </div>
    <div class="member-table-wrap">
      <table class="member-table">
        <thead>
          <tr><th>成员姓名</th><th>用户名</th><th>角色</th><th>操作</th></tr>
        </thead>
        <tbody>
          <tr v-for="q in qcMembers" :key="q.id">
            <td>
              <div class="member-name">
                <span class="member-avatar" style="background:#e6a23c">{{ getInitial(q) }}</span>
                <span>{{ q.name || q.Username || q.username || '-' }}</span>
              </div>
            </td>
            <td class="td-muted">{{ q.Username || q.username || '-' }}</td>
            <td><span class="role-badge" style="background:#fdf6ec;color:#e6a23c">{{ q.jkdRoleName || '复核员' }}</span></td>
            <td>
              <i class="el-icon-delete action-icon danger" title="移除" @click="removeQcMember(q)" style="margin-left:8px"></i>
            </td>
          </tr>
          <tr v-if="qcMembers.length === 0">
            <td colspan="4" style="text-align:center;color:#94a3b8;padding:32px 0;">暂无审核人员，请导入或在团队成员中添加 QC 角色</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- QC 门店分配弹窗 -->
    <el-dialog :visible.sync="dealerDialogVisible" width="640px" append-to-body custom-class="add-member-dialog" :show-close="false">
      <div class="dlg-header">
        <h3 class="dlg-title">分配审核门店</h3>
        <i class="el-icon-close dlg-close" @click="dealerDialogVisible = false"></i>
      </div>
      <div class="dlg-body">
        <div v-if="dealerUser" class="dlg-section" style="margin-bottom:12px">
          <span style="color:#64748b;font-size:14px">QC 成员：</span>
          <strong style="color:#0f172a">{{ dealerUser.name || dealerUser.Username || dealerUser.username }}</strong>
        </div>
        <div class="dlg-section">
          <label class="dlg-label">搜索并添加门店</label>
          <el-select v-model="dealerSelected" placeholder="输入门店编码或名称搜索" style="width:100%" class="dlg-select" filterable remote multiple :remote-method="searchDealers" :loading="dealerSearchLoading">
            <el-option v-for="d in dealerSearchResults" :key="d.id" :label="d.code ? `${d.code} - ${d.name}` : d.name" :value="d.id" />
          </el-select>
        </div>
        <div class="dlg-section" v-if="dealerExisting.length > 0">
          <label class="dlg-label" style="font-size:13px;color:#94a3b8">已分配门店 ({{ dealerExisting.length }})</label>
          <div style="max-height:200px;overflow-y:auto">
            <el-tag v-for="p in dealerExisting" :key="p.id" closable @close="removeQcDealer(p)" style="margin:0 6px 6px 0" size="medium">
              {{ p.mixedName || p.dealerName || ('门店#' + p.mixedId) }}
            </el-tag>
          </div>
        </div>
      </div>
      <div class="dlg-footer">
        <el-button @click="dealerDialogVisible = false" class="dlg-cancel-btn">取消</el-button>
        <el-button type="primary" @click="saveDealers" :loading="dealerSaving" class="dlg-confirm-btn">保存</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { deleteProjectMember } from '@/app/index/api/project/manager'
import { getPermissions, savePermissions, deletePermission } from '@/app/index/api/project/permission'
import { getInitial, downloadBlob } from './settingsHelpers'

export default {
  name: 'QcSection',
  props: {
    projectId: { type: [String, Number], required: true },
    qcMembers: { type: Array, default: () => [] }
  },
  data() {
    return {
      dealerDialogVisible: false,
      dealerUser: null,
      dealerSelected: [],
      dealerExisting: [],
      dealerSearchResults: [],
      dealerSearchLoading: false,
      dealerSaving: false,
      dealerCountMap: {}
    }
  },
  computed: {
    uploadUrl() {
      return (process.env.VUE_APP_BASE_URL || '') + '/ProjectManager/project/importQcReviewers'
    },
    uploadHeaders() {
      return { Authorization: 'Bearer ' + (localStorage.getItem('ACCESS_TOKEN') || '') }
    }
  },
  watch: {
    qcMembers() { this.loadDealerCounts() }
  },
  mounted() { this.loadDealerCounts() },
  methods: {
    getInitial,
    // 适配项目封装的 axios.get(url, params, options) 签名
    async exportTemplate() {
      try {
        const res = await this.axios.get(
          '/ProjectManager/project/exportQcTemplate',
          { projectId: this.projectId },
          { responseType: 'blob' }
        )
        downloadBlob(res, 'QC审核人员模板.xlsx')
      } catch (e) { this.$message.error('导出模板失败') }
    },
    onImportSuccess(res) {
      const data = res.data || res
      if (data.message || data.created !== undefined) {
        this.$message.success(data.message || `导入完成：新建${data.created || 0}，关联${data.linked || 0}，跳过${data.skipped || 0}，门店分配${data.permLinked || 0}`)
        this.$emit('refresh')
      } else { this.$message.error(data.message || '导入失败') }
    },
    onImportError() { this.$message.error('导入失败') },
    removeQcMember(member) {
      const name = member.name || member.Username || member.username || '该成员'
      this.$confirm(`确定要移除 ${name} 吗？`, '提示', { type: 'warning', customClass: 'settings-confirm-dialog' })
        .then(async () => {
          try {
            await deleteProjectMember(member.id)
            this.$message.success('已移除')
            this.$emit('refresh')
          } catch (e) {
            if (e !== 'cancel' && e !== 'close') this.$message.error(e?.data?.message || e?.message || '移除失败')
          }
        }).catch(() => {})
    },
    // 🔧 Bug修复: 串行改为 Promise.all 并行查询
    async loadDealerCounts() {
      if (!this.qcMembers || this.qcMembers.length === 0) return
      const promises = this.qcMembers.map(async q => {
        const uid = q.UserId || q.userId || q.uid
        try {
          const res = await getPermissions({ uid, projectId: parseInt(this.projectId) })
          const d = res?.data?.data
          const list = Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : [])
          return { uid, count: list.filter(p => p.dataType === 4 || p.data_type === 4).length }
        } catch (e) { return { uid, count: 0 } }
      })
      const results = await Promise.all(promises)
      const map = {}
      results.forEach(r => { map[r.uid] = r.count })
      this.dealerCountMap = { ...map }
    },
    async showDealerDialog(member) {
      this.dealerUser = member
      this.dealerSelected = []
      this.dealerExisting = []
      this.dealerSearchResults = []
      this.dealerDialogVisible = true
      const uid = member.UserId || member.userId || member.uid
      try {
        const res = await getPermissions({ uid, projectId: parseInt(this.projectId) })
        const d = res?.data?.data
        this.dealerExisting = (Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : [])).filter(p => p.dataType === 4 || p.data_type === 4)
      } catch (e) { console.error('加载QC权限失败', e) }
    },
    async searchDealers(query) {
      this.dealerSearchLoading = true
      try {
        const { data } = await this.axios.get('/Region/dealer/search', { params: { keyword: query || '' } })
        this.dealerSearchResults = data.data?.data || data.data || data || []
      } catch (e) { console.error('搜索经销商失败', e) }
      finally { this.dealerSearchLoading = false }
    },
    async removeQcDealer(perm) {
      try {
        await deletePermission({ id: perm.id })
        this.dealerExisting = this.dealerExisting.filter(p => p.id !== perm.id)
        this.$message.success('已移除')
        this.loadDealerCounts()
      } catch (e) { this.$message.error('移除失败') }
    },
    async saveDealers() {
      if (!this.dealerSelected || this.dealerSelected.length === 0) {
        return this.$message.warning('请选择要分配的门店')
      }
      const uid = this.dealerUser.UserId || this.dealerUser.userId || this.dealerUser.uid
      const existingIds = this.dealerExisting.map(p => p.mixedId)
      const allPerms = [...this.dealerExisting.map(p => ({ dataType: 4, mixedId: p.mixedId }))]
      this.dealerSelected.forEach(id => {
        if (!existingIds.includes(id)) allPerms.push({ dataType: 4, mixedId: id })
      })
      this.dealerSaving = true
      try {
        await savePermissions({ uid, projectId: parseInt(this.projectId), permissions: allPerms })
        this.$message.success('门店分配保存成功')
        const res = await getPermissions({ uid, projectId: parseInt(this.projectId) })
        const d = res?.data?.data
        this.dealerExisting = (Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : [])).filter(p => p.dataType === 4 || p.data_type === 4)
        this.dealerSelected = []
        this.loadDealerCounts()
      } catch (e) { this.$message.error(e?.data?.message || '保存失败') }
      finally { this.dealerSaving = false }
    }
  }
}
</script>
